<template>
  <div id="Statistics">

    <Head />
    <div class="hotspot clear">
      <Nav ms="/Statistics" />
      <div class="H-right">
        <div class="title">成果统计分析</div>
        <div class="btnselect">
          <div class="btn" v-for="(item, index) in tablist" :key="index" @click="btnclick(index)"
            :class="{ btnchange: btnnum == index }">{{ index == 0 ? '近五年成果数量分析' : '成果按专业分类分析' }}</div>
        </div>
        <div v-show="btnnum">
          <div class="H-header">
            <span v-if="type == 2">按省份统计</span>
            <select v-if="type == 2" v-model="provincecode" @change="getcompany()">
              <option value>请选择省份</option>

              <option :value="item.Code" v-for="(item, index) in provinces" :key="index">{{ item.Province }}</option>
            </select>
            <span v-if="type == 2">按单位统计</span>
            <select v-if="type == 2" v-model="companyid" :disabled="companys.length > 0 ? false : true">
              <option value>请选择单位</option>
              <option :value="item.ID" v-for="(item, index) in companys" :key="index">{{ item.Name }}</option>
            </select>
            <div class="btn btnmini" @click="bar()">统计分析</div>
          </div>
          <div class="t_main" id="bar" style="width: 12rem;height:9rem;"></div>
        </div>
        <div v-show="!btnnum">
          <div class="H-header">
            <span>按年份</span>
            <select v-model="chooseyear">
              <option value>请选择年份</option>
              <option :value="item.years" v-for="(item, index) in yeararr" :key="index">{{ item.years }}</option>
            </select>
            <span v-if="type == 2">按省份统计</span>
            <select v-if="type == 2" v-model="provincecode1" @change="getcompany1()">
              <option value selected>请选择省份</option>
              <option :value="item.Code" v-for="(item, index) in provinces1" :key="index">{{ item.Province }}</option>
            </select>
            <span v-if="type == 2">按单位统计</span>
            <select v-if="type == 2" v-model="companyid1" :disabled="companys1.length > 0 ? false : true">
              <option value selected>请选择单位</option>
              <option :value="item.ID" v-for="(item, index) in companys1" :key="index">{{ item.Name }}</option>
            </select>
            <div class="btn btnmini" @click="line()">统计分析</div>
          </div>
          <div v-show="options1.length > 0">
            <div class="t_main" id="line" style="width: 12rem;height:9rem;"></div>
            <div class="proportion">
              <ul>
                <li v-for="(item1, index) in direction" :key="index">
                  <div class="top" v-show="item1.sl">
                    <i class="dot" :style="{ 'background': item1.dot }"></i>
                    <p>
                      <span>{{ item1.first }}</span>
                      <span>数量：{{ item1.sl }}</span>
                      <span>占比：{{ item1.proportion }}%</span>
                    </p>
                  </div>
                  <div class="bottom">
                    <ul>
                      <li v-for="(item2, i) in item1.second" :key="i">
                        <span class="name" :style="{ 'background': item1.color[i] }">{{ item2 }}</span>
                        <p>
                          <span>数量：{{ item1.num[i] }}</span>
                          <span>占比：{{ item1.zb[i] }}</span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="message" v-show="options1.length == 0">
            <img src="../../assets/back/zanwu.png" alt />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import "echarts-gl";
export default {
  name: "Jurisdiction",
  data() {
    return {
      total: 1,
      btnnum: true,
      provinces: [],
      companys: [],
      provinces1: [],
      companys1: [],
      tableData: [1],
      tablist: [1, 1],
      yeararr: [],
      Page1: 1,
      type: sessionStorage.getItem("type"),
      PageSize1: 10,
      isPopup: true,
      options: [],
      options1: [],
      provincecode1: "", // 查询条件
      companyid1: "",
      provincecode: "", // 查询条件
      companyid: "",
      chooseyear: "",
      direction: [
        {
          first: "",
          sl: "",
          proportion: "",
          second: [],
          color: [
            "#c23531",
            "#2f4554",
            "#61a0a8",
            "#d48265",
            "#91c7ae",
            "#749f83",
          ],
          dot: "#96d6d6",
          num: [],
          zb: [],
        },
        // zb:[31.67,15,3.33,8.33,16.67,25]
        {
          first: "",
          sl: "",
          proportion: "",
          second: [],
          color: [
            "#c23531",
            "#2f4554",
            "#61a0a8",
            "#d48265",
            "#91c7ae",
            "#749f83",
            "#ca8622",
          ],
          dot: "#f6a66b",
          num: [],
          zb: [],
        },
        {
          first: "",
          sl: "",
          proportion: "",
          second: [],
          color: ["#c23531", "#2f4554", "#61a0a8", "#d48265", "#91c7ae"],
          dot: "#f17aba",
          num: [],
          zb: [],
        },
        {
          first: "",
          sl: "",
          proportion: "",
          second: [],
          color: [
            "#c23531",
            "#2f4554",
            "#61a0a8",
            "#d48265",
            "#91c7ae",
            "#749f83",
          ],
          dot: "#d35270",
          num: [],
          zb: [],
        },
        {
          first: "",
          sl: "",
          proportion: "",
          second: [],
          color: ["#c23531", "#2f4554", "#61a0a8", "#d48265"],
          dot: "#88aad0",
          num: [],
          zb: [],
        },
      ],
    };
  },
  created() {
    this.city();
    this.year();
  },
  mounted() {
    this.city();
    this.year();
    this.bar();
    this.line();
  },
  methods: {
    btnclick() {
      this.btnnum = !this.btnnum;
    },
    getyearmethod: function (event) {
      this.yearValues = event.target.value;
    },

    getcompany() {
      this.companyid = "";
      //获取当前选中的值，并重新赋值
      this.$axios
        .post("company/index?province=" + this.provincecode)
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            let arr = res.data.data.list;
            arr.shift();
            this.companys = arr;
            console.log(this.companys);
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        });
    },
    getcompany1() {
      this.companyid1 = "";
      //获取当前选中的值，并重新赋值
      this.$axios
        .post("company/index?province=" + this.provincecode1)
        .then((res) => {
          if (res.data.code == 10000) {
            let arr = res.data.data.list;
            arr.shift();
            this.companys1 = arr;
            console.log(this.companys1);
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        });
    },
    year() {
      this.$axios.post("reportresult/SelectYear").then((res) => {
        let arr = res.data.data;
        // arr.shift();
        this.yeararr = arr;
        console.log(this.yeararr);
      });
    },

    city() {
      this.$axios.post("province/index").then((res) => {
        this.provinces = res.data.data;
        this.provinces1 = res.data.data;
      });
    },

    bar() {
      var myChart = this.$echarts.init(document.getElementById("bar"));
      var that = this;
      that.$axios
        .post(
          "statistic/fiveyears?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            province: this.provincecode,
            company: this.companyid,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.options = res.data.data;
            console.log(res.data.data);
            // console.log();
            let years = [];
            let nums = [];
            this.options.forEach((val, index) => {
              console.log(val);
              years.push(val.year);
              nums.push([index, 0, val.num]);
            });
            myChart.setOption({
              xAxis3D: {
                // data: [
                //   this.options[0]["year"],
                //   this.options[1]["year"],
                //   this.options[2]["year"],
                //   this.options[3]["year"],
                //   this.options[4]["year"]
                // ]
                data: years,
              },
              series: [
                {
                  data: nums,
                  // data: [
                  //   [0, 0, this.options[0]["num"]],
                  //   [1, 0, this.options[1]["num"]],
                  //   [2, 0, this.options[2]["num"]],
                  //   [3, 0, this.options[3]["num"]],
                  //   [4, 0, this.options[4]["num"]]
                  //   // this.options[1]["num"],
                  //   // this.options[2]["num"],
                  //   // this.options[3]["num"],
                  //   // this.options[4]["num"]
                  // ]
                },
              ],
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          show: false,
          backgroundColor: "rgba(255,255,255,0.9)",
        },
        xAxis3D: {
          type: "category",
          name: "",
          data: [],
          axisLine: {
            lineStyle: {
              color: "#0f0",
              width: 1,
            },
          },
          nameTextStyle: {},
          axisLabel: {
            interval: 0,
            // rotate: 20,
            textStyle: {
              color: "#909399",
              fontSize: 16,
            },
          },
        },
        yAxis3D: {
          name: "",
          type: "category",
          data: [""],

          axisLine: {
            lineStyle: {
              color: "#67C23A",
              width: 1,
            },
          },
        },
        zAxis3D: {
          name: "",
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#67C23A",
              width: 1,
            },
          },
        },
        grid3D: {
          boxWidth: 200,
          boxDepth: 20,
          axisPointer: {
            show: false,
          },
          light: {
            main: {
              intensity: 1.2,
            },
            ambient: {
              intensity: 0.3,
            },
          },
          viewControl: {
            alpha: 0,
            beta: 0,
            // autoRotate: true,
            zoomSensitivity: 0,
            autoRotateAfterStill: 15,
            distance: 250,
          },
        },
        series: [
          {
            type: "bar3D",
            name: "1",
            barSize: 15,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = [
                    "#c23531",
                    "#2f4554",
                    "#61a0a8",
                    "#d48265",
                    "#91c7ae",
                    "#a00398",
                    "#E87C25",
                    "#C6E579",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            label: {
              show: true, //开启显示
              // distance : 12, //在上方显示
              textStyle: {
                //数值样式
                color: "#a66",
                fontSize: 16,
              },
            },
            data: [
              // [0, 0, 18000],
              // [1, 0, 10000],
              // [2, 0, 6000],
              // [3, 0, 18000],
              // [4, 0, 10000]
              // [5, 0, 6000],
              // [6, 0, 18000],
              // [7, 0, 10000]
            ],

            stack: "stack",
            shading: "lambert",
            emphasis: {
              label: {
                show: true,
              },
            },
          },
        ],
        // title: {
        //   //text: 'ECharts 入门示例'
        // },
        // tooltip: {},
        // legend: {
        //   data: ["份"]
        // },
        // xAxis: {
        //   data: []
        // },
        // yAxis: {},
        // series: [
        //   {
        //     name: "数量",
        //     type: "bar",
        //     data: [],
        //     label: {
        //       normal: {
        //         show: true,
        //         position: "top",
        //         // 数据在柱子头部显示
        //         textStyle: {
        //           color: "#5475c7",
        //           fontSize: 16
        //         }
        //       }
        //     },
        //     // itemStyle: {
        //     //   normal: {
        //     //     //每根柱子颜色设置
        //     //     color: function(params) {
        //     //       let colorList = [
        //     //         "#61a0a8",
        //     //         "#d48265",
        //     //         "#91c7ae",
        //     //         "#749f83",
        //     //         "#ca8622",
        //     //         "#bda29a",
        //     //         "#6e7074",
        //     //         "#546570",
        //     //         "#c4ccd3",
        //     //         "#4BABDE",
        //     //         "#FFDE76",
        //     //         "#E43C59",
        //     //         "#37A2DA"
        //     //       ];
        //     //       return colorList[params.dataIndex];
        //     //     }
        //     //   },
        //     //   shadowOffsetX: 5,
        //     //   shadowOffsetY: 5,
        //     //   shadowColor: "rgba(97,160,168,1)",
        //     //   shadowBlur: 10
        //     //   // shadowColor: function(params) {
        //     //   //   let shadowColorList = [
        //     //   //     "rgba(97,160,168,.2)",
        //     //   //     "rgba(212,130,101,.2)",
        //     //   //     "rgba(145,199,174,.2)",
        //     //   //     "rgba(116,159,131,.2)",
        //     //   //     "rgba(116,159,131,.2)"
        //     //   //   ];
        //     //   //   return shadowColorList[params.dataIndex];
        //     //   // }
        //     // }
        //   }
        // ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    keepTwoDecimal(num) {
      var result = parseFloat(num);
      if (isNaN(result)) {
        //  alert('传递参数错误，请检查！');
        return false;
      }
      result = Math.round(num * 1000) / 1000;
      return result;
    },
    toObj2(key, val) {
      var data = { [key]: val };
      return data;
    },
    unique(arr) {
      let obj = {};
      let peon = arr.reduce((cur, next) => {
        obj[next.name] ? "" : (obj[next.name] = true && cur.push(next));
        return cur;
      }, []);
      console.log(peon);
      return peon;
    },
    line() {
      var myChart = this.$echarts.init(document.getElementById("line"));
      console.log(this.provincecode1);
      var data = [];
      this.$axios.post("classification/index?SuperiorD=0").then((res) => {
        data = res.data.data.list;
        console.log(data);
      });

      let that = this;
      that.$axios
        .post(
          "statistic/classify?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            year: this.chooseyear,
            province: this.provincecode1,
            company: this.companyid1,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            that.options1 = res.data.data;
            console.log(that.options1);
            let parent = [];
            let son = [];
            that.direction.forEach((val) => {
              val.num = [];
              val.second = [];
              val.zb = [];
              val.first = "";
              val.sl = "";
              val.proportion = "";
            });
            that.options1.forEach((item) => {
              // if(item.ParentClassname=="战略管理与商业模式"){
              //   that.direction[0].num.push(item.num)
              // }
              switch (item.ParentClassname) {
                case "战略管理与商业模式":
                  that.direction[0].num.push(item.num);
                  that.direction[0].second.push(item.Classname);
                  that.direction[0].zb.push(item.zb);
                  that.direction[0].sl = item.bignum;
                  that.direction[0].first = item.ParentClassname;
                  break;
                case "组织变革与集团管控":
                  that.direction[1].num.push(item.num);
                  that.direction[1].second.push(item.Classname);
                  that.direction[1].zb.push(item.zb);
                  that.direction[1].sl = item.bignum;
                  that.direction[1].first = item.ParentClassname;
                  break;
                case "生产运营与安全管理":
                  that.direction[2].num.push(item.num);
                  that.direction[2].second.push(item.Classname);
                  that.direction[2].zb.push(item.zb);
                  that.direction[2].sl = item.bignum;
                  that.direction[2].first = item.ParentClassname;
                  break;
                case "财务管理与金融管理":
                  that.direction[3].num.push(item.num);
                  that.direction[3].second.push(item.Classname);
                  that.direction[3].zb.push(item.zb);
                  that.direction[3].sl = item.bignum;
                  that.direction[3].first = item.ParentClassname;
                  break;
                case "供应链与物流管理":
                  that.direction[4].num.push(item.num);
                  that.direction[4].second.push(item.Classname);
                  that.direction[4].zb.push(item.zb);
                  that.direction[4].sl = item.bignum;
                  that.direction[4].first = item.ParentClassname;
                  break;
              }

              parent.push(
                Object.assign(
                  that.toObj2("name", item.ParentClassname),
                  that.toObj2("value", item.bignum)
                )
              );
              son.push(
                Object.assign(
                  that.toObj2("name", item.Classname),
                  that.toObj2("value", item.num)
                )
              );
            });
            var arrs = [];
            arrs = that.unique(parent);
            console.log(arrs);
            var sum = 0;
            that.direction.forEach((val) => {
              sum += val.sl * 1;
            });
            that.direction.forEach((val) => {
              val.proportion = (
                that.keepTwoDecimal(val.sl / sum) * 100
              ).toFixed(1);
            });
            myChart.setOption(
              // option
              {
                // dataZoom: [
                //   {
                //     type: "inside" //详细配置可见echarts官网
                //   }
                // ],
                series: [{ data: arrs }, { data: son }],
              }
            );
            // console.log(that.direction)
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        grid: {
          left: "90%",
          right: "60%",
          bottom: "50%",
          // containLabel: true
        },
        series: [
          {
            name: "",
            type: "pie",
            selectedMode: "single",
            radius: [0, "30%"],
            // itemStyle:{
            //   color:"rgba(128, 128, 128, 0.5)"
            // },
            color: ["#96d6d6", "#f6a66b", "#f17aba", "#d35270", "#88aad0"],
            label: {
              formatter: " {b|{b}：}   {per|{d}%}  ",
              backgroundColor: "rgba(255,255,255,.8)",
              itemStyle: {},
              borderColor: "#aaa",
              borderWidth: 1,
              borderRadius: 4,
              // height:60,
              // shadowBlur:3,
              // shadowOffsetX: 2,
              // shadowOffsetY: 2,
              // shadowColor: '#999',
              // padding: [0, 7],
              rich: {
                a: {
                  color: "#000",
                  lineHeight: 22,
                  align: "center",
                },

                // abg: {
                //     backgroundColor: '#333',
                //     width: '100%',
                //     align: 'right',
                //     height: 22,
                //     borderRadius: [4, 4, 0, 0]
                // },
                // hr: {
                //   borderColor: "#aaa",
                //   width: "100%",
                //   borderWidth: 0.5,
                //   height: 0
                // },
                b: {
                  color: "#343434",
                  fontSize: 16,
                  lineHeight: 33,
                },
                // c:{
                //    color : '#fff',
                // },
                per: {
                  color: "#000",
                  backgroundColor: "#fff",
                  padding: [2, 4],
                  borderRadius: 2,
                },
              },
            },
            labelLine: {
              show: true,
            },
            data: [],
            // data: [
            //   {
            //     value: 60,
            //     name: "战略管理与商业模式"
            //   },
            //   {
            //     value: 106,
            //     name: "组织变革与集团管控"
            //   },
            //   {
            //     value: 86,
            //     name: "生产运营与安全管理"
            //   },
            //   {
            //     value: 34,
            //     name: "财务管理与金融管理"
            //   },
            //   {
            //     value: 20,
            //     name: "供应链与物流管理"
            //   }
            // ]
          },
          {
            name: "",
            type: "pie",
            radius: ["60%", "80%"],
            labelLine: {
              show: false,
            },
            color: [
              "#c23531",
              "#2f4554",
              "#61a0a8",
              "#d48265",
              "#91c7ae",
              "#749f83",
              "#c23531",
              "#2f4554",
              "#61a0a8",
              "#d48265",
              "#91c7ae",
              "#749f83",
              "#ca8622",
              "#c23531",
              "#2f4554",
              "#61a0a8",
              "#d48265",
              "#91c7ae",
              "#c23531",
              "#2f4554",
              "#61a0a8",
              "#d48265",
              "#91c7ae",
              "#749f83",
              "#c23531",
              "#2f4554",
              "#61a0a8",
              "#d48265",
            ],
            label: {
              position: "inside",
              color: "transparent",
            },
            data: [],
            // data: [
            //   { value: 19, name: "战略规划" },
            //   { value: 9, name: "商业模式" },
            //   { value: 2, name: "品牌管理" },
            //   { value: 5, name: "双创建设" },
            //   { value: 10, name: "文化建设" },
            //   { value: 15, name: "社会责任" },
            //   { value: 21, name: "内部控制" },
            //   { value: 27, name: "企业改革" },
            //   { value: 5, name: "制度建设" },
            //   { value: 11, name: "两化融合-管理方向" },
            //   { value: 18, name: "人力资源" },
            //   { value: 5, name: "绩效管理" },
            //   { value: 19, name: "风险管理" },
            //   { value: 14, name: "精益管理" },
            //   { value: 17, name: "生产管理" },
            //   { value: 41, name: "安全管理" },
            //   { value: 10, name: "技术管理" },
            //   { value: 4, name: "两化融合-生产方向" },
            //   { value: 3, name: "全面预算管理" },
            //   { value: 5, name: "审计管理" },
            //   { value: 22, name: "成本费用管控" },
            //   { value: 1, name: "货币资金管理" },
            //   { value: 0, name: "应收账款" },
            //   { value: 3, name: "融资管理" },
            //   { value: 3, name: "企业内部采购" },
            //   { value: 8, name: "物资管理" },
            //   { value: 2, name: "物流管理" },
            //   { value: 7, name: "营销管理" }
            // ]
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
  components: {
    Head,
    Foot,
    Nav,
  },
};
</script>
<style scoped lang="less">
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn {
  width: 2rem;
  cursor: pointer;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  background: #426cc4;
  color: #fff;
}

.btnchange {
  background-color: #f2f2f4;
  color: #000000;
}

.btnmini {
  width: 1rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.05rem;
}

.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 11.17rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;

    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }

    .btnselect {
      display: flex;
    }

    .H-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 0.5rem;

      span,
      select,
      div {
        margin-right: 0.2rem;
      }

      select {
        width: 2rem;
        height: 0.4rem;
      }
    }

    .message {
      img {
        width: 80%;
        height: 80%;
        display: block;
        margin: 0.5rem auto 0.2rem;
      }

      p {
        text-align: center;
        color: lightgray;
        font-size: 0.4rem;
      }
    }

    .proportion {
      >ul {
        >li {
          font-size: 0.2rem;
          margin-bottom: 0.3rem;

          .top {
            margin-bottom: 0.15rem;

            .dot {
              width: 0.15rem;
              height: 0.15rem;
              display: inline-block;
              // background: pink;
              float: left;
              border-radius: 50%;
              margin-right: 0.1rem;
              margin-top: 0.06rem;
            }

            p {
              span {
                margin-right: 0.2rem;
              }
            }
          }

          .bottom {
            font-size: 0.13rem;
            margin-left: 0.2rem;

            ul {
              display: flex;

              // justify-content: space-between;
              li {

                // margin-right: 0.4rem;
                // display: flex;
                .name {
                  display: block;
                  width: 1.6rem;
                  text-align: center;
                  // background: lightseagreen;
                  color: #fff;
                  // text-align: center;
                  border-radius: 0.08rem;
                  margin-right: 0.22rem;
                  padding: 0.07rem 0;
                  margin-bottom: 0.1rem;
                }

                p {
                  span:first-of-type {
                    margin-right: 0.2rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>